var map = {
	"app/pages/acciones/acciones.module": [
		"../../../../../src/app/pages/acciones/acciones.module.ts",
		"common",
		"acciones.module"
	],
	"app/pages/administrativo/actividades/actividades.module": [
		"../../../../../src/app/pages/administrativo/actividades/actividades.module.ts",
		"common",
		"actividades.module"
	],
	"app/pages/administrativo/areas/areas.module": [
		"../../../../../src/app/pages/administrativo/areas/areas.module.ts",
		"common",
		"areas.module"
	],
	"app/pages/administrativo/dependencias-areas/dependencia.areas.module": [
		"../../../../../src/app/pages/administrativo/dependencias-areas/dependencia.areas.module.ts",
		"common",
		"dependencia.areas.module"
	],
	"app/pages/administrativo/dependencias/dependencias.module": [
		"../../../../../src/app/pages/administrativo/dependencias/dependencias.module.ts",
		"common",
		"dependencias.module"
	],
	"app/pages/administrativo/objetivos-especificos/objetivos.especificos.module": [
		"../../../../../src/app/pages/administrativo/objetivos-especificos/objetivos.especificos.module.ts",
		"common",
		"objetivos.especificos.module"
	],
	"app/pages/administrativo/puestos/puestos.module": [
		"../../../../../src/app/pages/administrativo/puestos/puestos.module.ts",
		"common",
		"puestos.module"
	],
	"app/pages/administrativo/usuarios-dependencias/usuarios.dependencias.module": [
		"../../../../../src/app/pages/administrativo/usuarios-dependencias/usuarios.dependencias.module.ts",
		"common",
		"usuarios.dependencias.module"
	],
	"app/pages/autoevaluacion/dashboard-autoevaluacion/dashboard.autoevaluacion.module": [
		"../../../../../src/app/pages/autoevaluacion/dashboard-autoevaluacion/dashboard.autoevaluacion.module.ts",
		"common",
		"dashboard.autoevaluacion.module"
	],
	"app/pages/autoevaluacion/estado-autoevaluacion/estado.autoevaluaciones.module": [
		"../../../../../src/app/pages/autoevaluacion/estado-autoevaluacion/estado.autoevaluaciones.module.ts",
		"common",
		"estado.autoevaluaciones.module"
	],
	"app/pages/autoevaluacion/parametrizacion-autoevaluacion/autoevaluaciones/autoevaluaciones.module": [
		"../../../../../src/app/pages/autoevaluacion/parametrizacion-autoevaluacion/autoevaluaciones/autoevaluaciones.module.ts",
		"common",
		"autoevaluaciones.module"
	],
	"app/pages/autoevaluacion/parametrizacion-autoevaluacion/componentes/componentes.module": [
		"../../../../../src/app/pages/autoevaluacion/parametrizacion-autoevaluacion/componentes/componentes.module.ts",
		"common",
		"componentes.module"
	],
	"app/pages/autoevaluacion/parametrizacion-autoevaluacion/estados-cumplimiento/estados.cumplimientos.module": [
		"../../../../../src/app/pages/autoevaluacion/parametrizacion-autoevaluacion/estados-cumplimiento/estados.cumplimientos.module.ts",
		"common",
		"estados.cumplimientos.module"
	],
	"app/pages/autoevaluacion/parametrizacion-autoevaluacion/parametrizacion.autoevaluacion.module": [
		"../../../../../src/app/pages/autoevaluacion/parametrizacion-autoevaluacion/parametrizacion.autoevaluacion.module.ts",
		"common",
		"parametrizacion.autoevaluacion.module"
	],
	"app/pages/autoevaluacion/reportes-autoevaluacion/kendo/reportes.autoevaluacion.kendo.module": [
		"../../../../../src/app/pages/autoevaluacion/reportes-autoevaluacion/kendo/reportes.autoevaluacion.kendo.module.ts",
		"common",
		"reportes.autoevaluacion.kendo.module"
	],
	"app/pages/autoevaluacion/reportes-autoevaluacion/reportes.autoevaluacion.module": [
		"../../../../../src/app/pages/autoevaluacion/reportes-autoevaluacion/reportes.autoevaluacion.module.ts",
		"common",
		"reportes.autoevaluacion.module"
	],
	"app/pages/autoevaluacion/reportes-autoevaluacion/telerik/reportes.autoevaluacion.telerik.module": [
		"../../../../../src/app/pages/autoevaluacion/reportes-autoevaluacion/telerik/reportes.autoevaluacion.telerik.module.ts",
		"common",
		"reportes.autoevaluacion.telerik.module"
	],
	"app/pages/configuracion-sistema/configuracion-alertas/configuracion.alertas.module": [
		"../../../../../src/app/pages/configuracion-sistema/configuracion-alertas/configuracion.alertas.module.ts",
		"common",
		"configuracion.alertas.module"
	],
	"app/pages/configuracion-sistema/configuracion-correos/configuracion.correos.module": [
		"../../../../../src/app/pages/configuracion-sistema/configuracion-correos/configuracion.correos.module.ts",
		"common",
		"configuracion.correos.module"
	],
	"app/pages/configuracion-sistema/configuracion-foto-perfil/configuracion.foto.perfil.module": [
		"../../../../../src/app/pages/configuracion-sistema/configuracion-foto-perfil/configuracion.foto.perfil.module.ts",
		"common",
		"configuracion.foto.perfil.module"
	],
	"app/pages/configuracion-sistema/configuracion-logo/configuracion.logo.module": [
		"../../../../../src/app/pages/configuracion-sistema/configuracion-logo/configuracion.logo.module.ts",
		"common",
		"configuracion.logo.module"
	],
	"app/pages/connections/connections.module": [
		"../../../../../src/app/pages/connections/connections.module.ts",
		"common",
		"connections.module"
	],
	"app/pages/estructuras/estructura.module": [
		"../../../../../src/app/pages/estructuras/estructura.module.ts",
		"common",
		"estructura.module"
	],
	"app/pages/generador-reportes/generador.reportes.module": [
		"../../../../../src/app/pages/generador-reportes/generador.reportes.module.ts",
		"common",
		"generador.reportes.module"
	],
	"app/pages/incidentes/incidentes.module": [
		"../../../../../src/app/pages/incidentes/incidentes.module.ts",
		"common",
		"incidentes.module"
	],
	"app/pages/incidentes/reportes-incidente/reportes.incidente.module": [
		"../../../../../src/app/pages/incidentes/reportes-incidente/reportes.incidente.module.ts",
		"common",
		"reportes.incidente.module"
	],
	"app/pages/incidentes/reportes-incidente/telerik/reportes.incidente.telerik.module": [
		"../../../../../src/app/pages/incidentes/reportes-incidente/telerik/reportes.incidente.telerik.module.ts",
		"common",
		"reportes.incidente.telerik.module"
	],
	"app/pages/login/login.module": [
		"../../../../../src/app/pages/login/login.module.ts",
		"common",
		"login.module"
	],
	"app/pages/logs/error-logs/error.logs.module": [
		"../../../../../src/app/pages/logs/error-logs/error.logs.module.ts",
		"common",
		"error.logs.module"
	],
	"app/pages/logs/evento-logs/evento.logs.module": [
		"../../../../../src/app/pages/logs/evento-logs/evento.logs.module.ts",
		"common",
		"evento.logs.module"
	],
	"app/pages/pages.module": [
		"../../../../../src/app/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"app/pages/register/register.module": [
		"../../../../../src/app/pages/register/register.module.ts",
		"register.module"
	],
	"app/pages/riesgos/administrar-riesgos/administrar.riesgos.module": [
		"../../../../../src/app/pages/riesgos/administrar-riesgos/administrar.riesgos.module.ts",
		"common",
		"administrar.riesgos.module"
	],
	"app/pages/riesgos/dashboard-riesgo/dashboard.riesgo.module": [
		"../../../../../src/app/pages/riesgos/dashboard-riesgo/dashboard.riesgo.module.ts",
		"common",
		"dashboard.riesgo.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/actividad-controles/actividad-controles.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/actividad-controles/actividad-controles.module.ts",
		"common",
		"actividad-controles.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/calificaciones/calificaciones.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/calificaciones/calificaciones.module.ts",
		"common",
		"calificaciones.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/efectividades-controles/efectividades.controles.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/efectividades-controles/efectividades.controles.module.ts",
		"common",
		"efectividades.controles.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/impactos/impactos.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/impactos/impactos.module.ts",
		"common",
		"impactos.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/parametrizacion.riesgo.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/parametrizacion.riesgo.module.ts",
		"common",
		"parametrizacion.riesgo.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/periodos/periodos.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/periodos/periodos.module.ts",
		"common",
		"periodos.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/portafolio/portafolio.riesgos.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/portafolio/portafolio.riesgos.module.ts",
		"common",
		"portafolio.riesgos.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/probabilidades/probabilidades.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/probabilidades/probabilidades.module.ts",
		"common",
		"probabilidades.module"
	],
	"app/pages/riesgos/parametrizacion-riesgo/tipos-riesgo/tipos.riesgo.module": [
		"../../../../../src/app/pages/riesgos/parametrizacion-riesgo/tipos-riesgo/tipos.riesgo.module.ts",
		"common",
		"tipos.riesgo.module"
	],
	"app/pages/riesgos/reportes-riesgo/kendo/reportes.kendo.module": [
		"../../../../../src/app/pages/riesgos/reportes-riesgo/kendo/reportes.kendo.module.ts",
		"common",
		"reportes.kendo.module"
	],
	"app/pages/riesgos/reportes-riesgo/reportes.riesgo.module": [
		"../../../../../src/app/pages/riesgos/reportes-riesgo/reportes.riesgo.module.ts",
		"common",
		"reportes.riesgo.module"
	],
	"app/pages/riesgos/reportes-riesgo/telerik/reportes.riesgo.telerik.module": [
		"../../../../../src/app/pages/riesgos/reportes-riesgo/telerik/reportes.riesgo.telerik.module.ts",
		"common",
		"reportes.riesgo.telerik.module"
	],
	"app/pages/seguridad/permisos/permisos.module": [
		"../../../../../src/app/pages/seguridad/permisos/permisos.module.ts",
		"common",
		"permisos.module"
	],
	"app/pages/seguridad/roles-permisos/roles.permisos.module": [
		"../../../../../src/app/pages/seguridad/roles-permisos/roles.permisos.module.ts",
		"common",
		"roles.permisos.module"
	],
	"app/pages/seguridad/roles/roles.module": [
		"../../../../../src/app/pages/seguridad/roles/roles.module.ts",
		"common",
		"roles.module"
	],
	"app/pages/seguridad/usuarios-permisos/usuarios.permisos.module": [
		"../../../../../src/app/pages/seguridad/usuarios-permisos/usuarios.permisos.module.ts",
		"common",
		"usuarios.permisos.module"
	],
	"app/pages/seguridad/usuarios/usuarios.module": [
		"../../../../../src/app/pages/seguridad/usuarios/usuarios.module.ts",
		"common",
		"usuarios.module"
	],
	"app/pages/tareas.acciones/tareas.acciones.module": [
		"../../../../../src/app/pages/tareas.acciones/tareas.acciones.module.ts",
		"common",
		"tareas.acciones.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Synergy/Projects/SFE/Synergy.UI/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main